<template>
  <div class="home_index">
    <el-container>
      <el-header class="top_header" height="50px">
        <top-header/>
      </el-header>
      <el-container style="height: 100%;">
        <el-aside width="auto" style="overflow-x: hidden;z-index:7;">
          <left-menu/>
        </el-aside>
        <el-main>
          <tags></tags>
          <contain/>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import LeftMenu from './leftMenu';
import TopHeader from './topHeader';
import Contain from './contain';
import tags from '../comm/tags';

export default {
  name: 'layout',
  components: {
    LeftMenu,
    TopHeader,
    Contain,
    tags
  },
  methods: {
    ...mapActions({
      setMenuData: 'user/setMenuData'
    })
  },
  created() {
    this.setMenuData();
  }
};
</script>

<style lang="scss">
.home_index {
  height: 100%;
  width: 100%;
  display: flex;

  .el-aside {
    background: #ffffff;
  }

  .top_header {
    background-color: #2b2f32;
    min-width: 520px;

    > div > img {
      display: inline-block;
      margin: 10px 10px 5px 0;
      float: left;
    }
  }

  .el-container > .el-scrollbar {
    .el-scrollbar__wrap {
      overflow-x: hidden;

      .el-menu-vertical-demo {
        border-right: 0;
      }
    }
  }

  .el-main {
    padding: 0;
  }
}
</style>
